import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    title: '电影频道',
    desc: '最新高清电影在线看',
    icon: 'ri-film-line',
    to: '/category/movie',
    tone: 'bg-primary-500 text-background-50',
  },
  {
    title: '电视剧频道',
    desc: '热播剧集持续更新',
    icon: 'ri-tv-2-line',
    to: '/category/tv',
    tone: 'bg-secondary-500 text-background-50',
  },
  {
    title: '热门推荐',
    desc: '高人气口碑作品',
    icon: 'ri-fire-line',
    to: '/search?q=热门',
    tone: 'bg-accent-500 text-primary-950',
  },
  {
    title: '最新上线',
    desc: '刚刚更新抢先看',
    icon: 'ri-timer-flash-line',
    to: '/search?q=最新',
    tone: 'bg-primary-900 text-background-50',
  },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.title}
            to={entry.to}
            className="group flex items-center gap-4 p-4 md:p-5 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-md ${entry.tone}`}>
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">{entry.title}</h3>
              <p className="text-xs text-foreground-500 mt-0.5 truncate">{entry.desc}</p>
            </div>
            <span className="ml-auto w-6 h-6 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}